var TableCellData_VerticalAlignment = /* @__PURE__ */ ((TableCellData_VerticalAlignment2) => {
  TableCellData_VerticalAlignment2["TOP"] = "TOP";
  TableCellData_VerticalAlignment2["MIDDLE"] = "MIDDLE";
  TableCellData_VerticalAlignment2["BOTTOM"] = "BOTTOM";
  TableCellData_VerticalAlignment2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return TableCellData_VerticalAlignment2;
})(TableCellData_VerticalAlignment || {});
export {
  TableCellData_VerticalAlignment
};
//# sourceMappingURL=plugin_table_cell.enums.js.map
